if (!window.customElements.get("newsletter-klaviyo-form")) {

    class NewsletterKlaviyoForm extends HTMLElement {
        constructor() {
            super();

            this.selectors = {
                form: "[data-newsletter-form]",
                checkbox: "[data-newsletter-select-checkbox]",
                listIdInput: "[data-newsletter-list-id]",
                email: "[data-newsletter-email]",
                success: "[data-newsletter-success]",
                error: "[data-newsletter-error]",
                subscribed: "[data-newsletter-subscribed]",
                messageText: "[data-newsletter-message-text]"
            };

            this.modifiers = {
                hide: "hidden"
            };

            this.apiURL = "https://manage.kmail-lists.com/ajax/subscriptions/subscribe";

        }

        connectedCallback() {
            this.initKlaviyo()
        }

        initKlaviyo() {
            this.form = this.querySelector(this.selectors.form);
            this.listId = this.querySelector(this.selectors.listIdInput).value;
            this.errorEl = this.querySelector(this.selectors.error);
            this.successEl = this.querySelector(this.selectors.success);
            this.subscribedEl = this.querySelector(this.selectors.subscribed);

            this.form.addEventListener("submit", sendRequest.bind(this));

            function sendRequest(e) {
                e.preventDefault();

                const emailVal = this.querySelector(
                    this.selectors.email
                ).value;


                this.sendToList(this.listId, emailVal);
            }
        }

        sendToList(list, email) {
            let settings = {
                method: "POST",
                headers: {
                    "content-type": "application/x-www-form-urlencoded",
                    "cache-control": "no-cache"
                },

                body: new URLSearchParams({
                    g: list,
                    email: email
                })
            };

            fetch(this.apiURL, settings)
                .then((response) => response.json())
                .then((data) => {
                    console.log(data);
                    if (data.success) {
                        if (data.data.is_subscribed) {
                            this.displaySubscribedMessage();
                        } else {
                            this.displaySuccessMessage();
                        }
                    } else {
                        this.displayErrorMessage(data.errors);
                    }
                });
        }

        displayErrorMessage(text) {
            this.successEl.classList.add(this.modifiers.hide);
            this.subscribedEl.classList.add(this.modifiers.hide);
            this.errorEl.classList.remove(this.modifiers.hide);
            this.errorEl.querySelector(this.selectors.messageText).innerHTML = text[0];
        }

        displaySuccessMessage(text) {
            this.errorEl.classList.add(this.modifiers.hide);
            this.subscribedEl.classList.add(this.modifiers.hide);
            this.successEl.classList.remove(this.modifiers.hide);

        }

        displaySubscribedMessage(text) {
            this.errorEl.classList.add(this.modifiers.hide);
            this.successEl.classList.add(this.modifiers.hide);
            this.subscribedEl.classList.remove(this.modifiers.hide);
        }

        addListeners() {
            document.addEventListener('shopify:section:reorder', () => this.initSlider());
            document.addEventListener('shopify:section:load', () => this.initSlider());
            document.addEventListener('shopify:section:select', () => this.initSlider());
            document.addEventListener('shopify:section:deselect', () => this.initSlider());

        }
    }


    customElements.define('newsletter-klaviyo-form', NewsletterKlaviyoForm);
}
